import { LANGUAGE_CHANGE } from "./types"

export const changeLang = lang => dispatch =>
  dispatch({
    type: LANGUAGE_CHANGE,
    payload: lang,
  })
